export enum RequestLawyerRegistrationStatus {
	Active = "ACTIVE",
	Inactive = "INACTIVE",
	NotRegistered = "NOT_REGISTERED",
}
